import { NavigationItem } from '@/types'

/**
 * Main navigation menu items
 */
export const navigationItems: NavigationItem[] = [
  {
    label: 'Home',
    href: '/',
    isPrimary: false,
  },
  {
    label: 'Services',
    href: '/services',
    isPrimary: false,
  },
  {
    label: 'Why Us',
    href: '/why-us',
    isPrimary: false,
  },
  {
    label: 'Pricing',
    href: '/pricing',
    isPrimary: false,
  },
  {
    label: 'FAQ',
    href: '/faq',
    isPrimary: false,
  },
  {
    label: 'Contact',
    href: '/contact',
    isPrimary: false,
  },
]

/**
 * Primary CTA button in navigation
 */
export const primaryCTA: NavigationItem = {
  label: 'Get a Free Consultation',
  href: '/contact',
  isPrimary: true,
}
